export default __webpack_public_path__ + "static/media/apple.d78f2c19.svg";